<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card" v-if="success">
        <div class="card-body">
            <div class="alertd alert-success text-center text-success g">
                <h3>
                    <img :src="require('@/assets/images/done.png')" style="border-radius: 50%; width: 120px" alt="">
                    <br><br>
                    {{ success }}
                </h3>
            </div>
        </div>
    </div>
    <div class="card" v-if="!success">
        <div class="card-header">
            <h5 v-if="type == 'add-file'"><i class="fa fa-plus"></i> إضافة العقد </h5>
            <h5 v-if="type == 'upload-image'"><i class="fa fa-upload"></i> رفع الصورة الشخصية لإصدار بطاقة نسك</h5>
            (الخطوة {{ step }} من {{ totalPages }})
        </div>
        <div class="card-body">

            <strong class="text-danger">* تشير إلى أنّ السؤال مطلوب</strong>
        </div>
        <div class="card-body" style="padding: 10px" v-if="type == 'add-file'">
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> البريد الالكتروني
            <strong class="text-danger">*</strong></h5>
              <input type="email"
                class="form-control form-control-lg" v-model="create.email" placeholder="اكتب هنا...">
            </div>
           <div class="form-group text-left g">
                <h5 for="">نأمل منك التكرم برفع العقد بعد توقيعه 
                    <strong class="text-danger">*</strong>
                    <span v-if="create.file == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file != '' && create.file" class="text-success">
                        (تم الرفع)
                    </span>
                </h5>
                <input type="file"
                class="form-control" id="file" @change="create.file = 'uploading'; upload2()" accept=".jpg,.jpeg,.png,.pdf">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-success" style="background: #578E7E !important; border: none" @click="done()">
                    <i class="fa fa-check"></i>
                    إرسال الآن
                </button>
                <br><br>
                <a href="javascript:;" class="text-muted" @click="step = 2; top()"><i class="fa fa-share"></i> الصفحة السابقة</a>
            </div>
        </div>
        <div class="card-body" style="padding: 10px" v-if="type == 'upload-image'">
            <div class="form-group g borders" style="border-radius: 5px">
              <h5 for=""><i class="fa fa-edit"></i> البريد الالكتروني
            <strong class="text-danger">*</strong></h5>
              <input type="email"
                class="form-control form-control-lg" v-model="create.email" placeholder="اكتب هنا...">
            </div>
           <div class="form-group text-left g">
                <h5 for="">الصورة الشخصية

                    <strong class="text-danger">*</strong>
                    <span v-if="create.file == 'uploading'">
                        <img :src="require('@/assets/images/loading.svg')" alt="" width="24"> جاري الرفع
                    </span>
                    <span v-if="create.file != '' && create.file" class="text-success">
                        (تم الرفع)
                    </span>
                </h5>
                <input type="file"
                class="form-control" id="file" @change="create.file = 'uploading'; upload2()" accept=".jpg,.jpeg,.png,.pdf">
            </div>
            <div class="col-12 text-center g">
                <button class="btn btn-success" style="background: #578E7E !important; border: none" @click="done()">
                    <i class="fa fa-check"></i>
                    إرسال الآن
                </button>
                <br><br>
                <a href="javascript:;" class="text-muted" @click="step = 2; top()"><i class="fa fa-share"></i> الصفحة السابقة</a>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            step: 1,
            totalPages: 1,
            create: {

            },
            success: null,
            type: window.location.href.split("/create2/")[1]
        }
    },
    methods: {
        top(){
            $("html, body").animate({ scrollTop: 0 }, "slow");
        },
        upload2(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            var Upload = function (file) {
                this.file = file;
            };

            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());

                $.ajax({
                type: "POST",
                url: api + '/user/web/upload',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    if(data.status != 100){
                        alert("هذه الصورة غير مدعومة", 200)
                        return;
                    }
                    g.create.file = data.response;
                    g.create = JSON.parse(JSON.stringify(g.create))
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };
            var file = $("#file")[0].files[0];
            var upload = new Upload(file);
            upload.doUpload();
        },
        done(){
            var g = this;
            g.create = JSON.parse(JSON.stringify(g.create))
            //
            if(!g.create.file){ alert(`حقل الملف مطلوب`, 200); g.step = 1; return g.top(); }
            if(!g.create.email){ alert(`حقل البريد الالكتروني مطلوب`, 200); g.step = 1; return g.top(); }
            //
            $.post(api + '/user/forms/create', {
                create: JSON.stringify(g.create),
                type: g.type
            }).then(function(r){
                if(r.status == 100){
                    g.success = "تم الارسال بنجاح"
                }else{
                    alert(r.response, 200)
                }
            }).fail(function(){
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>

</style>